import services from "@/http";
import * as types from "./mutation-types";

export const ActionSetMessage = ({ commit }, payload) => {
  commit(types.SET_MESSAGE, payload);
};

export const ActionGetAll = async ({ commit, dispatch }, payload) => {
  try {
    const response = await services.config.all_alerts(payload);
    commit(types.SET_ALERTS, response.data?.data);
    dispatch("ActionSetPagination", response.data);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const ActionGetCount = async ({ commit }) => {
  try {
    const response = await services.config.unread_count();
    commit(types.SET_COUNT, response.data?.unread);

    return response.data?.unread;
  } catch (error) {}
};

export const ActionSetRead = async ({ commit, dispatch }, payload) => {
  try {
    const response = await services.config.mark_read(payload);
    dispatch("ActionGetCount");
    dispatch("ActionGetAll");

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};
